import type {
  BeneficialOwnerFormDataInput,
  RelatedPartyFormDataInput,
} from "Components/Users/schemas";
import { type PartyDto, RelationType } from "Infrastructure/Api/Api";
import type { DeepPartial } from "react-hook-form";
import { addressDtoToValidationSchema } from "Schemas/addressSchemas";
import { PersonalIdentification } from "Utils/PersonalIdentification";

const computeBirthDate = ({
  birthDate,
  personalNumber,
}: PartyDto): string | undefined => {
  if (birthDate) {
    return birthDate;
  }

  if (personalNumber) {
    const { IsValid, BirthDate } =
      PersonalIdentification.getInfo(personalNumber);

    if (IsValid && BirthDate) {
      return BirthDate.toISOString();
    }
  }

  return undefined;
};

export const mapBeneficialOwnerPartyDtoFormData = (
  partyDto: PartyDto,
): DeepPartial<BeneficialOwnerFormDataInput> => ({
  ...partyDto,
  publicID: partyDto.publicID ?? undefined,
  firstName: partyDto.firstName ?? undefined,
  lastName: partyDto.lastName ?? undefined,
  personalNumber: partyDto.personalNumber ?? undefined,
  birthDate: computeBirthDate(partyDto),
  nationality: partyDto.nationality ?? undefined,
  addresses: partyDto.addresses?.map(addressDtoToValidationSchema) ?? [],
  relationType: RelationType.BeneficialOwner,
  isOwner: true,
});

export const mapOtherRelatedPartyDtoToFormData = (
  partyDto: PartyDto,
  relationType: RelationType,
  isOwner?: boolean,
): DeepPartial<RelatedPartyFormDataInput> => ({
  ...partyDto,
  publicID: partyDto.publicID ?? undefined,
  firstName: partyDto.firstName ?? undefined,
  lastName: partyDto.lastName ?? undefined,
  birthDate: computeBirthDate(partyDto),
  nationality: partyDto.nationality ?? undefined,
  addresses: partyDto.addresses?.map(addressDtoToValidationSchema) ?? [],
  taxNumber: partyDto.taxNumber ?? undefined,
  companyNumber: partyDto.companyNumber ?? undefined,
  companyName: partyDto.companyName ?? undefined,
  partyIdentification: partyDto.partyIdentification ?? {},
  relationType,
  isOwner: isOwner ?? false,
});
